import Button from 'components/button'
import { ReactChild, VFC } from 'react'
import { SectionError } from 'theme/error';
import { TitleError, TextError } from './components/style/text'

export interface GenericErrorProps {
  error?: ReactChild
  description?: ReactChild
  onRetry?: () => void
  buttonText?: ReactChild
}

const GenericError: VFC<GenericErrorProps> = ({ error = '', description = '', onRetry, buttonText }) => {
  const safeError = error || (
    <>
      ¡Chin! <br />
      Algo no salió como debería.
    </>
  )

  const safeDescription = description || <>Tranqui... que todo tiene solución.</>

  return (
    <SectionError className="w-auto flex-1 flex flex-col justify-center items-center max-w-full space-y-4 mx-8 my-8 w-full">
      <div className="flex-1  flex flex-col itemx-center justify-center gap-4">
        <TitleError className="text-center text-3xl uppercase font-bold">{safeError}</TitleError>
        <TextError className="text-center mx-2">{safeDescription}</TextError>
      </div>
      {(onRetry && buttonText) && (
        <Button
          onClick={() => {
            gtag('event', 'Click', {
              event_category: GTM_EVENT_CATEGORY,
              event_label: 'ERROR - Reintentar',
              value: '10'
            })
            onRetry()
          }}
        >
          {buttonText || 'REINTENTAR'}
        </Button>
      )}
    </SectionError>
  )
}

export default GenericError
